import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AzureDataExplorerIcon = props => (
  <Icon viewBox="0 0 721 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-361 0)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M420.8 58.8 1023.2 661.2C1031.45 670.712 1045.85 671.736 1055.36 663.488 1060.64 658.912 1063.52 652.172 1063.2 645.2L1063.2 42.8C1063.22 30.2079 1053.02 19.9859 1040.43 19.9684 1040.02 19.9678 1039.61 19.9784 1039.2 20L436.8 20C424.209 20.1336 414.11 30.4492 414.243 43.0408 414.306 48.9444 416.656 54.594 420.8 58.8Z"
                stroke="currentColor"
                strokeWidth="40"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M583.2 221.2 860.8 498.8 1060.8 298.8 1060.8 42.8C1060.82 30.662 1051.32 20.6388 1039.2 20L784.4 20Z"
                stroke="currentColor"
                strokeWidth="40"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M634.892 399.214C639.11 394.996 645.948 394.996 650.165 399.214L682.975 432.024C687.193 436.241 687.193 443.08 682.975 447.297L433.225 697.048C429.007 701.265 422.169 701.265 417.952 697.048L385.142 664.238C380.924 660.02 380.924 653.182 385.142 648.964Z"
                stroke="currentColor"
                strokeWidth="40"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M539.444 301.884C543.662 297.666 550.5 297.666 554.718 301.884L587.527 334.693C591.745 338.911 591.745 345.749 587.527 349.967L433.378 504.116C429.16 508.334 422.322 508.334 418.105 504.116L385.295 471.307C381.077 467.089 381.077 460.251 385.295 456.033Z"
                stroke="currentColor"
                strokeWidth="40"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M730.408 494.215C734.625 489.997 741.463 489.997 745.681 494.215L778.491 527.025C782.708 531.242 782.708 538.081 778.491 542.298L624.341 696.448C620.124 700.665 613.286 700.665 609.068 696.448L576.258 663.638C572.041 659.42 572.041 652.582 576.258 648.364Z"
                stroke="currentColor"
                strokeWidth="40"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M752.818 186.683C758.754 180.747 768.378 180.747 774.314 186.683L800.901 213.27C806.837 219.206 806.837 228.83 800.901 234.766L774.314 261.353C768.378 267.289 758.754 267.289 752.818 261.353L726.231 234.766C720.295 228.83 720.295 219.206 726.231 213.27Z"
                stroke="currentColor"
                strokeWidth="40"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M848.818 90.518C854.754 84.582 864.378 84.582 870.314 90.518L896.901 117.105C902.837 123.041 902.837 132.665 896.901 138.601L870.314 165.189C864.378 171.124 854.754 171.124 848.818 165.189L822.231 138.601C816.295 132.665 816.295 123.041 822.231 117.105Z"
                stroke="currentColor"
                strokeWidth="40"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M848.983 282.683C854.919 276.747 864.543 276.747 870.479 282.683L897.066 309.27C903.002 315.206 903.002 324.83 897.066 330.766L870.479 357.353C864.543 363.289 854.919 363.289 848.983 357.353L822.395 330.766C816.459 324.83 816.459 315.206 822.395 309.27Z"
                stroke="currentColor"
                strokeWidth="40"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M918.4 213.2 944.8 186.8C950.708 180.835 960.332 180.789 966.296 186.696 966.332 186.73 966.364 186.765 966.4 186.8L992.8 213.2C998.764 219.107 998.812 228.731 992.904 234.696 992.868 234.731 992.836 234.766 992.8 234.8L966.4 261.2C960.492 267.165 950.868 267.211 944.904 261.304 944.868 261.27 944.836 261.235 944.8 261.2L918.4 234.8C912.436 228.893 912.388 219.269 918.296 213.304 918.332 213.269 918.364 213.234 918.4 213.2"
                stroke="currentColor"
                strokeWidth="40"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
